export default __webpack_public_path__ + "static/media/uploader-medtronic-3.a1c225f2.png";